<!-- content section -->
<div class="card-layout">
  <!-- Header always visible -->
  <div class="d-flex flex-row align-items-center psic-gap-4">
    <img src="assets/images/payment-method.svg" alt="payment-method" class="card-image" />
    <div class="card-header">Payment method</div>
    @if (isLoading()) {
    <app-card-loader></app-card-loader>
    }
  </div>

  @if (!isLoading() && !dcPolicyFailed && !dcBillingFailed) {
  <div class="separator"></div>
  @if (editMode()) {
  <!-- Edit Payment Method -->
  <div class="content-section d-flex flex-column align-items-start psic-gap-6">
    <h6>{{ globalMessages.editPaymentMethodHeading }}</h6>
    <ng-container
      [ngTemplateOutlet]="editPaymentMethodTemplate"
      [ngTemplateOutletContext]="{}"
    ></ng-container>
  </div>
  } @else if (showForm()) {
  <!-- Add Payment Method -->
  <div class="content-section d-flex flex-column align-items-start psic-gap-6">
    <h6>{{ globalMessages.addPaymentMethodHeading }}</h6>
    <ng-container
      [ngTemplateOutlet]="addPaymentMethodTemplate"
      [ngTemplateOutletContext]="{}"
    ></ng-container>
  </div>
  } @else if(!autoEnrollInd() && !showAutoEnroll){
  <!-- This template will be load when below scenario met
    Auto enroll pay = false
    page = make Paymentamount is selected -->
  <div class="content-section d-flex flex-column align-items-start psic-gap-6">
    <ng-container
      [ngTemplateOutlet]="paymentTemplate"
      [ngTemplateOutletContext]="{}"
    ></ng-container>
  </div>
  } @else {
  <!-- List down all payment methods -->
  <div class="d-flex flex-column psic-gap-6">
    @if (showAutoEnroll) {
    <div class="d-flex flex-row align-items-center justify-content-between">
      <!-- Auto Enroll Pay toggle field -->
      <lib-input-toggle
        [(ngModel)]="autoEnrollPayField.value"
        [field]="autoEnrollPayField"
        (ngModelChange)="updateAutoEnrollField($event, true)"
      ></lib-input-toggle>
    </div>
    @if (!autoEnrollInd()) {
    <lib-alert
      [alertText]="globalMessages.autoPayPaperInvoiceDisclaimer"
      [alertTheme]="'default'"
      [alertType]="'small'"
    ></lib-alert>
    } @if (autoEnrollInd() && savedCards() && savedCards().length == 0) {
    <lib-alert
      [alertText]="globalMessages.autoPaySetDefaultNotice"
      [alertTheme]="'warning'"
      [alertType]="'small'"
    ></lib-alert>
    } @if (autoEnrollInd() && cardExpired() && savedCards() && savedCards().length == 1) {
    <lib-alert
      [alertText]="globalMessages.expiredDefaultPayMsg"
      [alertTheme]="'error'"
      [alertType]="'small'"
    ></lib-alert>
    } @if (autoEnrollInd() && cardExpired() && savedCards() && savedCards().length > 1) {
    <lib-alert
      [alertText]="
        'Your default payment method has expired. Please select a different payment method.'
      "
      [alertTheme]="'error'"
      [alertType]="'small'"
    ></lib-alert>
    } } @if (loadingPaymentDetails()) {
    <app-card-loader></app-card-loader>
    } @else { @if ((autoEnrollInd() || !showAutoEnroll) && savedCards() && savedCards().length > 0)
    { @for (item of savedCards(); track item; let i = $index) {
    <ng-container
      [ngTemplateOutlet]="savedPaymentTemplate"
      [ngTemplateOutletContext]="{ item: item }"
    ></ng-container>
    } } } @if (autoEnrollInd()) {
    <div class="d-flex flex-row justify-content-center w-100">
      <lib-button
        [buttonType]="'borderless'"
        [buttonSize]="'large'"
        [buttonText]="globalMessages.buttonAddNewPaymentMethod"
        [disabled]="!userAccess.hasEditableAccess()"
        (callback)="addPaymentMethod()"
      ></lib-button>
    </div>
    }
  </div>
  }}
</div>

<!-- Card Template on landing -->
<ng-template #savedPaymentTemplate let-item="item">
  <div class="cards d-flex flex-column psic-gap-2 w-100">
    @if (item.isDefault && autoEnrollInd() && item.id != cardExpiredId) {
    <div class="psic-mb-4">
      <lib-alert
        [alertText]="globalMessages.defaultPaymentSuccessMsg"
        [alertType]="'small'"
        [alertTheme]="'success'"
      ></lib-alert>
    </div>
    }
    <div class="d-flex flex-row justify-content-between w-100">
      <div class="d-flex flex-row align-items-center psic-gap-2">
        <input
          class="form-check-input input-radio-btn"
          type="radio"
          name="'radioField'"
          [checked]="item.isDefault && item.id != cardExpiredId"
          [value]="item.id"
          [disabled]="item.id === cardExpiredId || !userAccess.hasFullAccess()"
          (click)="setAsDefault(item); $event.preventDefault()"
        />
        @if (item.paymentMethodType === globalMessages.paymentTypeCreditCard) {
        <span class="caption-bold">{{ item.type | uppercase }} **** {{ item.lastFour }}</span>
        } @if (item.paymentMethodType === globalMessages.paymentTypeEft) {
        <span class="caption-bold"
          >{{ item.bankAccountType | uppercase }} **** {{ item.lastFour }}</span
        >
        } @if (item.isDefault && item.id != cardExpiredId) {
        <lib-tag
          class="psic-ml-2"
          [tagText]="'Default'"
          [tagTheme]="'success'"
          [tagType]="'lineFill'"
        ></lib-tag>
        } @if (item.isDefault && item.id === cardExpiredId) {
        <lib-tag
          class="psic-ml-2"
          [tagText]="'Default'"
          [tagTheme]="'error'"
          [tagType]="'lineFill'"
        ></lib-tag>
        }
      </div>
      @if (item.paymentMethodType === globalMessages.paymentTypeCreditCard) {
      <img [src]="item.logoSrc" style="height: 32px" />
      }
    </div>
    <div class="d-flex flex-row justify-content-between align-items-center w-100">
      <div class="d-flex flex-column">
        <span class="caption">{{ item.cardholderName }}</span>
        @if (item.paymentMethodType === globalMessages.paymentTypeCreditCard && item.id !=
        cardExpiredId) {
        <span class="caption" style="font-style: italic">Good thru {{ item.expiryDate }}</span>
        } @if (item.paymentMethodType === globalMessages.paymentTypeCreditCard && item.id ===
        cardExpiredId) {
        <span class="caption error-90-color">Good thru {{ item.expiryDate }}</span>
        } @if (item.paymentMethodType === globalMessages.paymentTypeEft) {
        <span class="caption" style="font-style: italic">
          {{ item.bankName }} - {{ item.bankAccountType }}
        </span>
        }
      </div>
      <div class="d-flex justify-content-end psic-gap-2">
        @if (item.paymentMethodType === globalMessages.paymentTypeCreditCard) {
        <lib-button
          [buttonType]="'icon'"
          [libIcon]="'edit'"
          (callback)="editCard(item)"
          [disabled]="!userAccess.hasFullAccess()"
        ></lib-button>
        } @if (!item.isDefault) {
        <lib-button
          [buttonType]="'icon'"
          [libIcon]="'close-circle'"
          (callback)="deleteCard(item)"
          [disabled]="!userAccess.hasFullAccess()"
        ></lib-button>
        }
      </div>
    </div>
  </div>
</ng-template>

<!-- Add New Payment Method Template -->
<ng-template #addPaymentMethodTemplate>
  @if (showForm()) {
  <div class="d-flex flex-column psic-gap-6 w-100">
    <!-- Save card radio: only shown in make-payment context (showAutoEnroll=false) -->
    @if (!showAutoEnroll) {
    <div class="d-flex flex-row justify-content-between align-items-center">
      <span class="caption-bold">{{ saveCardField.caption }}</span>
      @for (item of saveCardField.options.optionsList; track item; let i = $index) {
      <div class="d-flex align-items-center">
        <input
          class="form-check-input"
          type="radio"
          [name]="saveCardField.name"
          [id]="'saveCard' + i"
          [checked]="saveCardField.value === item.value"
          (change)="displayPaymentMethod(item.value)"
        />
        <label class="btn" [for]="'saveCard' + i">{{ item.caption }}</label>
      </div>
      }
    </div>
    }
    <!-- Choice buttons: always shown in billing page; shown after saveCard selection in make-payment -->
    @if (showAutoEnroll || saveCardField.value !== '') {
    <div
      class="d-flex flex-row psic-gap-4"
      [ngClass]="{ 'flex-row': !isMobile(), 'flex-column': isMobile() }"
    >
      @for (paymentMethod of paymentMethodField.options.optionsList; track paymentMethod) {
      <app-choice
        class="flex-grow-1"
        [value]="paymentMethod.value"
        [selected]="paymentMethodField.value == paymentMethod.value"
        [paymentOption]="paymentMethod"
        (selectedChanged)="selectPaymentMethod(paymentMethod.value, $event)"
      ></app-choice>
      }
    </div>
    }
    <div class="d-flex flex-column">
      @if (paymentMethodField.value) {
      <form #paymentForm="ngForm" name="form" class="d-flex flex-column psic-gap-6">
        <div class="d-flex flex-row justify-content-center align-items-center">
          <img
            [src]="oneIncLogo"
            alt="Terms-and-Conditions-img"
            [ngStyle]="{
              height: isMobile() ? '40px' : '59px',
              width: isMobile() ? '140px' : '188px',
              'margin-right': '8px'
            }"
          />
        </div>

        @if (paymentMethodField.value !== globalMessages.collectionMethodEFT) {
        <div class="d-flex flex-row align-items-center">
          <lib-input-toggle
            class="w-100"
            [(ngModel)]="differentBillingAddrToggle.value"
            [field]="differentBillingAddrToggle"
            name="{{ differentBillingAddrToggle.name }}"
            (ngModelChange)="changeAlternateBillingAddress($event)"
          ></lib-input-toggle>
        </div>

        @if (showBillingAddress()) {
        <div>
          <lib-input-address
            class="w-100 dont-auto-size-form-fields"
            name="{{ billingAddress.name }}"
            [field]="billingAddress"
            [(ngModel)]="billingAddress.value"
            (blur)="onBillingAddressChanged()"
          >
          </lib-input-address>
        </div>
        } }
        <lib-input-checkbox
          class="input-checkbox dont-auto-size-form-fields"
          name="{{ policyHolderCheckboxField.name }}"
          [(ngModel)]="policyHolderCheckboxField.value"
          [field]="policyHolderCheckboxField"
          (change)="toggleName(policyHolderCheckboxField.value)"
        ></lib-input-checkbox>
        @if (paymentMethodField.value !== globalMessages.collectionMethodEFT) {
        <lib-input-text
          class="dont-auto-size-form-fields"
          name="{{ cardHolderNameField.name }}"
          [(ngModel)]="cardHolderNameField.value"
          [field]="cardHolderNameField"
          (blur)="openPortalOneModal()"
        >
        </lib-input-text>
        } @if (paymentMethodField.value === globalMessages.collectionMethodEFT) {
        <lib-input-text
          class="dont-auto-size-form-fields"
          name="{{ accountHolderNameField.name }}"
          [(ngModel)]="accountHolderNameField.value"
          [field]="accountHolderNameField"
          (blur)="openPortalOneModal()"
        >
        </lib-input-text>
        }
      </form>
      }
      <div id="portalOneContainer"></div>
      <div
        class="d-flex psic-gap-6 psic-mt-8 w-100"
        [ngClass]="{
          'flex-row justify-content-center': !isMobile(),
          'flex-column align-items-center': isMobile()
        }"
      >
        <lib-button
          [buttonSize]="'large'"
          [buttonText]="globalMessages.buttonSavePaymentMethod"
          [disabled]="!isReadyToSave()"
          (callback)="saveNewPaymentMethod()"
        ></lib-button>
        <lib-button
          [buttonSize]="'large'"
          [buttonText]="globalMessages.buttonCancel"
          [buttonTheme]="'secondary'"
          (callback)="hidePaymentForm()"
        ></lib-button>
      </div>
    </div>
  </div>
  }
</ng-template>

<!-- Edit Payment Method Template -->
<ng-template #editPaymentMethodTemplate>
  @if (editMode()) {
  <div class="d-flex flex-column psic-mt-6 w-100">
    <form #editPaymentForm="ngForm" name="form">
      @if (editPaymentDetails.paymentMethodType !== globalMessages.paymentTypeEft) {
      <div class="d-flex flex-column psic-gap-6 w-100">
        <lib-input-toggle
          class="w-100"
          [(ngModel)]="differentBillingAddrToggle.value"
          [field]="differentBillingAddrToggle"
          name="{{ differentBillingAddrToggle.name }}"
          (ngModelChange)="changeAlternateBillingAddress($event)"
        ></lib-input-toggle>
        @if (showBillingAddress()) {
        <div>
          <lib-input-address
            class="w-100 dont-auto-size-form-fields"
            name="{{ billingAddress.name }}"
            [field]="billingAddress"
            [(ngModel)]="billingAddress.value"
            (blur)="validateExpirationDate()"
          >
          </lib-input-address>
        </div>
        }
        <lib-input-text
          class="dont-auto-size-form-fields"
          name="{{ cardHolderNameField.name }}"
          [(ngModel)]="cardHolderNameField.value"
          [field]="cardHolderNameField"
        >
        </lib-input-text>
        <lib-input-text
          class="dont-auto-size-form-fields"
          name="{{ cardNumberField.name }}"
          [(ngModel)]="cardNumberField.value"
          [field]="cardNumberField"
        >
        </lib-input-text>
        <div
          class="d-flex w-100"
          [ngClass]="{
            'flex-row': !isMobile(),
            'psic-gap-4': !isMobile(),
            'flex-column': isMobile()
          }"
        >
          <lib-dropdown
            class="dont-auto-size-form-fields w-100"
            name="{{ expirationMonthField.name }}"
            [(ngModel)]="expirationMonthField.value"
            [field]="expirationMonthField"
            (ngModelChange)="validateExpirationDate()"
          >
          </lib-dropdown>
          <lib-input-text
            class="dont-auto-size-form-fields w-100"
            name="{{ expirationYearField.name }}"
            [(ngModel)]="expirationYearField.value"
            [field]="expirationYearField"
            (ngModelChange)="validateExpirationDate()"
          >
          </lib-input-text>
        </div>
        @if (!editPaymentDetails.isDefault) {
        <lib-input-checkbox
          name="{{ defaultPaymentCheckboxField.name }}"
          [field]="defaultPaymentCheckboxField"
          [(ngModel)]="defaultPaymentCheckboxField.value"
        >
        </lib-input-checkbox>
        }
      </div>
      }
    </form>
    <div
      class="d-flex psic-gap-6 psic-mt-8 w-100"
      [ngClass]="{
        'flex-row justify-content-center': !isMobile(),
        'flex-column align-items-center': isMobile()
      }"
    >
      @if (isReadyToUpdate()) {
      <lib-button
        [buttonSize]="'large'"
        [buttonText]="globalMessages.buttonUpdatePaymentMethod"
        [disabled]="false"
        (callback)="updateCard()"
      ></lib-button>
      }
      <lib-button
        [buttonSize]="'large'"
        [buttonText]="globalMessages.buttonCancel"
        [buttonTheme]="'secondary'"
        (callback)="hidePaymentForm()"
      ></lib-button>
    </div>
  </div>
  }
</ng-template>

<!-- Credit card authorization disclaimer, shown before a card is saved or made default -->
<ng-template #ccDisclaimerDialog>
  <div class="psic-p-7">
    <div class="d-flex flex-row justify-content-center align-items-center psic-pb-6">
      <img
        [src]="oneIncLogo"
        alt="Terms-and-Conditions-img"
        [ngStyle]="{
          height: isMobile() ? '54px' : '82px',
          width: isMobile() ? '140px' : '240px'
        }"
      />
    </div>

    <div class="psic-mb-9">
      <p class="alt psic-pb-4">{{ ccDisclaimerMessage1 }}</p>
      <p class="alt">{{ ccDisclaimerMessage2 }}</p>
    </div>

    <div class="footer d-none d-md-flex align-items-center justify-content-center psic-gap-13">
      <lib-button
        [buttonText]="globalMessages.buttonCancel"
        [buttonSize]="'large'"
        [buttonType]="'borderless'"
        [libIcon]="'back'"
        [iconLeft]="true"
        (callback)="cancelDisclaimer()"
      ></lib-button>
      <lib-button
        [buttonText]="globalMessages.modalConfirmConfirm"
        [buttonSize]="'large'"
        (callback)="confirmDisclaimer()"
      ></lib-button>
    </div>
    <div
      class="mobile-footer d-flex d-md-none align-items-center justify-content-between psic-mt-4"
    >
      <lib-button
        [buttonText]="globalMessages.buttonCancel"
        [buttonTheme]="'tertiary'"
        [buttonSize]="'large'"
        [buttonType]="'borderless'"
        [libIcon]="'back'"
        [iconLeft]="true"
        (callback)="cancelDisclaimer()"
      ></lib-button>
      <lib-button
        [buttonText]="globalMessages.modalConfirmConfirm"
        [buttonTheme]="'tertiary'"
        [buttonSize]="'large'"
        (callback)="confirmDisclaimer()"
      ></lib-button>
    </div>
  </div>
</ng-template>

<!-- Payment Template -->
<ng-template #paymentTemplate>
  <div class="d-flex flex-column psic-gap-6 w-100">
    <!-- Choice buttons: always shown in billing page; shown after saveCard selection in make-payment -->
    <div
      class="d-flex flex-row psic-gap-4"
      [ngClass]="{ 'flex-row': !isMobile(), 'flex-column': isMobile() }"
    >
      @for (paymentMethod of paymentMethodField.options.optionsList; track paymentMethod) {
      <app-choice
        class="flex-grow-1"
        [value]="paymentMethod.value"
        [selected]="paymentMethodField.value == paymentMethod.value"
        [paymentOption]="paymentMethod"
        (selectedChanged)="selectPaymentMethod(paymentMethod.value, $event)"
      ></app-choice>
      }
    </div>
    <div class="d-flex flex-column">
      @if (paymentMethodField.value) {
      <form #paymentForm="ngForm" name="form" class="d-flex flex-column psic-gap-6">
        <img
          [src]="oneIncLogo"
          alt="Terms-and-Conditions-img"
          [ngStyle]="{
            height: isMobile() ? '40px' : '59px',
            width: isMobile() ? '140px' : '188px',
            'margin-right': '8px'
          }"
        />
        @if (paymentMethodField.value !== globalMessages.collectionMethodEFT) {
        <div class="d-flex flex-row align-items-center">
          <lib-input-toggle
            class="w-100"
            [(ngModel)]="differentBillingAddrToggle.value"
            [field]="differentBillingAddrToggle"
            name="{{ differentBillingAddrToggle.name }}"
            (ngModelChange)="changeAlternateBillingAddress($event)"
          ></lib-input-toggle>
        </div>

        @if (showBillingAddress()) {
        <div>
          <lib-input-address
            class="w-100 dont-auto-size-form-fields"
            name="{{ billingAddress.name }}"
            [field]="billingAddress"
            [(ngModel)]="billingAddress.value"
            (blur)="onBillingAddressChanged()"
          >
          </lib-input-address>
        </div>
        } }
        <lib-input-checkbox
          class="input-checkbox dont-auto-size-form-fields"
          name="{{ policyHolderCheckboxField.name }}"
          [(ngModel)]="policyHolderCheckboxField.value"
          [field]="policyHolderCheckboxField"
          (change)="toggleName(policyHolderCheckboxField.value)"
        ></lib-input-checkbox>
        @if (paymentMethodField.value !== globalMessages.collectionMethodEFT) {
        <lib-input-text
          class="dont-auto-size-form-fields"
          name="{{ cardHolderNameField.name }}"
          [(ngModel)]="cardHolderNameField.value"
          [field]="cardHolderNameField"
          (blur)="openPortalOneModal()"
        >
        </lib-input-text>
        } @if (paymentMethodField.value === globalMessages.collectionMethodEFT) {
        <lib-input-text
          class="dont-auto-size-form-fields"
          name="{{ accountHolderNameField.name }}"
          [(ngModel)]="accountHolderNameField.value"
          [field]="accountHolderNameField"
          (blur)="openPortalOneModal()"
        >
        </lib-input-text>
        }
      </form>
      }
      <div id="portalOneContainer"></div>
    </div>
  </div>
</ng-template>
